import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

const selectRecipientState = (state: RootState) => state.recipient;

export const selectNotificacoesRecebidas = createSelector(
  [selectRecipientState],
  (recipient) => recipient.notificacoes,
);

export const selectNotificacaoAtual = createSelector(
  [selectRecipientState],
  (recipient) => recipient.notificacaoAtual,
);

export const selectIsLoading = createSelector(
  [selectRecipientState],
  (recipient) => recipient.isLoading,
);

export const selectError = createSelector([selectRecipientState], (recipient) => recipient.error);

export const selectFilters = createSelector(
  [selectRecipientState],
  (recipient) => recipient.filters,
);

export const selectPagination = createSelector(
  [selectRecipientState],
  (recipient) => recipient.pagination,
);

const selectNotificacoesNaoLidas = createSelector([selectNotificacoesRecebidas], (notificacoes) =>
  notificacoes.filter((n) => !n.foiLida),
);

export const selectCountNaoLidas = createSelector(
  [selectNotificacoesNaoLidas],
  (naoLidas) => naoLidas.length,
);

export const selectHasMore = createSelector([selectPagination], (pagination) => pagination.hasMore);
